import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { CollaboratorItem } from "@ac-expo/api-types";
import { collaboratorQueryKeys } from "../query-keys/collaborator.query-keys";

const getCollaborators = async (asAcExpo?: boolean) => {
  const url = asAcExpo ? "collaborator/ac-expo" : "/collaborator";

  const { data } = await privateAxios.get<CollaboratorItem[]>(url);
  return data;
};

export const useGetCollaboratorsQuery = (asAcExpo?: boolean) => {
  return useQuery({
    queryKey: collaboratorQueryKeys.lists(asAcExpo),
    queryFn: () => getCollaborators(asAcExpo),
  });
};
